export default

class TransactionController{
  constructor(resource) {
      this._resource = resource;
  }

  getTransactionsByVehicleRequestId(vehicle_request_id) {
    return this._resource(`transactions/${vehicle_request_id}`)
      .get()
      .then(res => res.json())
      .catch(error => console.log(error))
  }

  getExtensionsByVehicleRequestId(vehicle_request_id) {
    return this._resource(`transactions/extensions/${vehicle_request_id}`)
      .get()
      .then(res => res.json())
      .catch(error => console.log(error))
  }
}
